import axios from 'axios';
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_API();


export default {

    wyslijInformacjeOKluczuMobilnym(key) {
        return axios({
            method: 'post',
            url: URL+'uzytk/dostep/mobilny?mobileKey='+key,
        })
    },

    wyczyscKluczMobilny() {
        return axios({
            method: 'post',
            url: URL+'uzytk/dostep/mobilny/wylacz',
        })
    },

    pobierzDaneNaDashboard() {
        return axios({
            method: 'get',
            url: URL+'dashboard',
        })
    },



}


// WEBPACK FOOTER //
// ./src/modules/home/HomeService.js